/**
 * UserSwitcher Component
 * Allows switching between test users in development mode.
 * Only visible when auth is disabled.
 */

import React from 'react';
import { TEST_USERS, getCurrentTestUser, setCurrentTestUser } from '../../config/testUsers';

const UserSwitcher = ({ onUserChange }) => {
  const currentUser = getCurrentTestUser();

  const handleUserChange = (e) => {
    const userId = e.target.value;
    setCurrentTestUser(userId);

    // Reload page to apply new user context
    if (onUserChange) {
      onUserChange(userId);
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-yellow-50 border border-yellow-200 rounded-lg">
      <span className="text-xs font-medium text-yellow-800">DEV MODE:</span>
      <select
        value={currentUser.id}
        onChange={handleUserChange}
        className="text-sm border border-yellow-300 rounded px-2 py-1 bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-yellow-400"
      >
        {TEST_USERS.map((user) => (
          <option key={user.id} value={user.id}>
            {user.name} ({user.email})
          </option>
        ))}
      </select>
    </div>
  );
};

export default UserSwitcher;
